// ** Theme Config Imports
import themeConfig from "src/configs/themeConfig";

const Button = (theme) => {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          lineHeight: 1.5,
          borderRadius: 9999,
          letterSpacing: "0.01em",
          padding: `${theme.spacing(1, 2)}`,
          textTransform: "none",
          boxShadow: "none",
          transition:
            "background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease",
        },
        contained: {
          boxShadow: "none",
          fontWeight: 600,
          minHeight: 40,
          padding: `${theme.spacing(1.125, 2.5)}`,
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: "none",
          },
        },
        outlined: {
          fontWeight: 500,
          minHeight: 40,
          padding: `${theme.spacing(1, 2.25)}`,
          borderWidth: 1.5,
          borderColor: theme.palette.customColors?.border || theme.palette.divider,
          "&:hover": {
            borderWidth: 1.5,
            borderColor: theme.palette.primary.main,
            backgroundColor:
              theme.palette.customColors?.navActiveBg || theme.palette.action.hover,
            boxShadow: "none",
          },
        },
        text: {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        sizeSmall: {
          padding: `${theme.spacing(0.75, 1.5)}`,
          fontSize: "0.8125rem",
        },
        sizeLarge: {
          minHeight: 44,
          padding: `${theme.spacing(1.375, 3)}`,
          fontSize: "0.9375rem",
          fontWeight: 600,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: themeConfig.disableRipple,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 9999,
        },
        sizeSmall: {
          padding: theme.spacing(1),
        },
        sizeMedium: {
          padding: theme.spacing(1.25),
        },
      },
    },
  };
};

export default Button;
